import React from "react";
import { useTranslation } from "react-i18next";
import BrandNav from "../../components/BrandNav";

export default function RoboticsSchools() {
  const { t } = useTranslation();
  return (
    <>
      <BrandNav />
      <main className="ftg-page">
        <h1>{t("robotics.schools_title")}</h1>
        <p>{t("robotics.schools_subtitle")}</p>
      </main>
    </>
  );
}
